export default __webpack_public_path__ + "static/media/typeship.72f79645.svg";